import { render } from "./facet-drawer-trigger.vue?vue&type=template&id=3a7dccbd"
import script from "./facet-drawer-trigger.vue?vue&type=script&lang=js"
export * from "./facet-drawer-trigger.vue?vue&type=script&lang=js"

import "./facet-drawer-trigger.vue?vue&type=style&index=0&id=3a7dccbd&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__